<div class="row">
  <p class="col-12 lead text-secondary mt-3 mb-4">
    POSH shows research and monitoring <b>sites</b> such as: stations,
    facilities, plots, moorings, observatories, platforms, supersites,
    community-based observations, and wherever repeat measurements have
    been made—compiled from multiple observing inventories.  Looking
    instead for observing <b>networks</b>?  See
    <a href="https://polarobservingregistry.org"
       target="_blank">RoPON</a>.
  </p>
  @if (window.innerWidth >= 992) {
  <app-home-filter class="col-sm-4 col-md-3 sticky-sidebar" />
  <div class="col">
    <div class="row">
	<p class="col-12 text-danger-emphasis fst-italic fw-bold">
	  Note: POSH is a prototype&mdash;a proof of concept&mdash;for
	  demonstration purposes only, and will be further developed to
	  meet user needs as resources allow.  For more information,
	  please <a routerLink="/contact">contact us</a>.
	</p>
      <div class="col position-relative">
	<div class="input-group">
	  <input type="text" class="form-control" [formControl]="ctrl"
		 placeholder="Search observing site"
		 area-label="Search" />
	</div>
	<i [class]="'bi-' + (ctrl.value ? 'x' : 'search')"
	   (click)="ctrl.setValue('')"></i>
      </div>
      <div class="col-auto pt-2">
	@if (model.lst().length < api.lst().length) {
	  {{model.lst().length | number}} of }
	{{api.lst().length | number}} total</div>
    </div>
    <div class="row mt-3">
      <ul class="nav nav-pills col-auto mx-auto mb-3">
	<li class="nav-item">
	  <a class="nav-link" [routerLink]="[]"
	     [queryParams]="model.setMode('map')"
	     [ngClass]="{'active': model.mode() == 'map'}">Map</a>
	</li>
	<li class="nav-item">
	  <a class="nav-link" [routerLink]="[]"
	     [queryParams]="model.setMode('list')"
	     [ngClass]="{'active': model.mode() == 'list'}">List</a>
	</li>
      </ul>
      @if (model.mode() == 'list') {
      <app-home-result class="col-12" /> }
      @else {
      <app-home-globe class="col-12" /> }
    </div>
  </div> }
  @else {
  <div class="mobile-sticky-bar col-12"
       [class.mobile-bar-hidden]="mobileBarHidden">
    <div class="position-relative">
      <div class="input-group">
	<input type="text" class="form-control" [formControl]="ctrl"
		 placeholder="Search observing site"
		 area-label="Search" />
	<i [class]="'bi-' + (ctrl.value ? 'x' : 'search')"
	   (click)="ctrl.setValue('')"></i>
      </div>
    </div>
    <app-home-filter class="d-block mt-2"
		     (mobileExpandedChange)="onMobileFilterExpanded($event)" />
  </div>
  <div class="ms-auto col-auto mt-2">
    @if (model.lst().length < api.lst().length) {
      {{model.lst().length | number}} of }
    {{api.lst().length | number}} total</div>
  <div class="col-12">
    <div class="row mt-3">
      <ul class="nav nav-pills col-auto mx-auto mb-3">
	<li class="nav-item">
	  <a class="nav-link" [routerLink]="[]"
	     [queryParams]="model.setMode('map')"
	     [ngClass]="{'active': model.mode() == 'map'}">Map</a>
	</li>
	<li class="nav-item">
	  <a class="nav-link" [routerLink]="[]"
	     [queryParams]="model.setMode('list')"
	     [ngClass]="{'active': model.mode() == 'list'}">List</a>
	</li>
      </ul>
    </div>
  </div>
  @if (model.mode() == 'list') {
  <app-home-result class="col-12" /> }
  @else {
  <app-home-globe class="col-12" /> } }
</div>
<div class="modal fade" id="splashModal" #splashModal tabindex="-1"
     aria-labelledby="splashModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg">
      <div class="modal-body text-center">
	<p>POSH compiles over 50,000 observing sites from multiple
	  inventories:</p>
    <a href="https://arcticobservingviewer.org" target="_blank">
      <img src="https://images.squarespace-cdn.com/content/v1/5273e59ae4b070db6e37803a/be85cc19-f00b-4a60-835d-12cb146be6f1/AOV_Logo_with_observation_sites.png"
	   style="width: 24em"
	   class="d-block mx-auto mb-2" alt="AOV" /></a>
    <a href="https://deims.org" target="_blank">
      <img src="https://deims.org/docs/_images/logo_title_inline_height50.png"
	   style="width: 14em"
	   class="d-block mx-auto mb-2" alt="DEIMS-SDR" /></a>
    <a href="https://eu-interact.org" target="_blank">
      <img src="https://eu-interact.org/app/uploads/2018/03/INTERACT-logo_high-resolution.png"
           style="width: 10em"
	   class="d-block mx-auto mb-3" alt="INTERACT" /></a>
    <a href="https://sios-svalbard.org" target="_blank">
      <img src="https://sios-svalbard.org/system/files/common/Logo-SIOS-ORIGINAL-rgb-simple_trimmed_small.png"
	   style="width: 8em"
	   class="d-block mx-auto mb-4" alt="SIOS" /></a>
	<p class="mb-0">As such, POSH does not replace these source
	  catalogs. <b>Instead, it relies on them and highlights the
	    need for their continued funding and support.</b></p>
      </div>
      <div class="modal-footer justify-content-center flex-column">
	<button type="button"
		class="btn btn-success px-3 fw-semibold fs-3"
		data-bs-dismiss="modal">Continue</button>
	<div class="form-check">
	  <input class="form-check-input" type="checkbox"
		 id="dontShowCheck" [(ngModel)]="dontShowAgain" />
	  <label class="form-check-label text-secondary small"
		 for="dontShowCheck">Don't show this again.</label>
	</div>
      </div>
    </div>
  </div>
</div>
